import React, { useEffect } from 'react'
import { Spin } from 'antd'
import { isEmpty, isNil } from 'lodash'
import PropTypes from 'prop-types'

import { showErrorNotification } from '../../core/helpers'

import { useMetadataQuery } from '../../common/hooks'

import { useLoggedInUser } from '../../account/hooks'

const MetadataProvider = ({ children }) => {
  const user = useLoggedInUser()

  const {
    isLoading: isMetadataLoading,
    error: metadataError,
    data,
    refetch: fetchMetadata,
  } = useMetadataQuery(true)

  useEffect(() => {
    if (metadataError) {
      showErrorNotification({
        title: 'Fetching metadata failed',
        description: metadataError.message,
      })
    }
  }, [metadataError])

  useEffect(() => {
    if (user) {
      fetchMetadata()
    }
  }, [fetchMetadata, user])

  if (!isNil(user) && (isMetadataLoading || isEmpty(data))) {
    return <Spin />
  }

  return children
}

MetadataProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default MetadataProvider
